import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { BillingService } from "../../shared/billing.service";

@Component({
  selector: 'app-billing-home',
  templateUrl: './billing-home.component.html',
  styleUrls: ['./billing-home.component.css'],
  standalone: false
})
export class BillingHomeComponent implements OnInit, OnDestroy {

  tabIndex = signal<number>(0);

  constructor(private billingService: BillingService) {
    try {
      const state = localStorage.getItem('org:billing:home');
      if (state) {
        this.tabIndex.set(JSON.parse(state).tabIndex);
      }
    } catch (e) {
      console.log(e);
    }
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    localStorage.setItem('org:billing:home', JSON.stringify({ tabIndex: this.tabIndex() }));
  }

}
